import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const NaviIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <circle cx="16" cy="16" r="4" fill="currentColor" />
    <circle
      cx="16"
      cy="16"
      r="10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      opacity="0.3"
    />
  </BaseIcon>
);
